import Faq from "@/components/faq";
import MetaComponent from "@/components/common/MetaComponent";
import { useEffect } from "react";
import { trackPageMount } from "@/utils/analytics";

const metadata = {
  title: "Hubzu | FAQ",
};

const FaqPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageMount({
      pageName: "faq_page_view",
      eventCategory: "FAQ Page",
      eventSource: "FAQ Page",
    });
  }, []);

  return (
    <>
      <MetaComponent meta={metadata} />
      <Faq />
    </>
  );
};

export default FaqPage;
